import React from "react";
import Flx from "../../layout/Flx";
import { Avatar, Box, Tooltip } from "@mui/material";
import {
  MailOutline,
  NumbersOutlined,
  Person,
  PhoneOutlined,
  StoreOutlined,
} from "@mui/icons-material";
import { isEmpty, isNil } from "lodash";
import Txt from "../../typography/Txt";
import { getFirstLetterOfString } from "../../../utils/strings/getFirstLetterOfString";
import { formatPhone } from "../../../_src_shared/utils/functions/formatPhone";

const LoanRelatedContactCardsRenderer = ({ loanRelatedContacts }) => {
  if (isEmpty(loanRelatedContacts)) {
    return (
      <>
        <Txt secondary>No related contacts added.</Txt>
      </>
    );
  }
  return (
    <Flx wrap g={1}>
      {loanRelatedContacts?.map((contact) => (
        <Flx
          column
          key={contact._id}
          sx={{
            p: 2,
            flexGrow: 0,
            borderRadius: 2,
            border: "1px solid #e5e7eb",
            minWidth: "280px",
          }}
        >
          <Flx ac gap={1.2}>
            <Avatar sx={{ width: "30px", height: "30px", fontSize: "14px" }}>
              {isNil(contact?.firstName) && isNil(contact?.lastName) ? (
                <Person sx={{ fontSize: "16px" }} />
              ) : (
                `${getFirstLetterOfString(contact?.firstName)}${getFirstLetterOfString(contact?.lastName)}`
              )}
            </Avatar>
            <Flx column>
              <Txt
                sx={{ fontSize: "12px", fontWeight: "bold", lineHeight: 1.4 }}
              >
                {contact?.firstName} {contact?.lastName}
              </Txt>
              <Tooltip title={"Role"} arrow placement="right">
                <Box sx={{ width: "max-content", mt: "-3px" }}>
                  <Txt sx={{ lineHeight: 1.2, fontStyle: "italic" }} secondary>
                    {contact?.loanRole}
                  </Txt>
                </Box>
              </Tooltip>
            </Flx>
          </Flx>

          <Flx column g={0.5} wrap sx={{ mt: 3, pl: "2px" }}>
            <Tooltip title={"Contact Email"} arrow placement="right">
              <Box sx={{ width: "max-content" }}>
                <Flx ac g={0.8} wrap>
                  <MailOutline sx={{ fontSize: "12px" }} className="thin" />
                  <Txt secondary>{contact?.emailAddress || "Unknown"}</Txt>
                </Flx>
              </Box>
            </Tooltip>
            <Tooltip title={"Contact Phone"} arrow placement="right">
              <Box sx={{ width: "max-content" }}>
                <Flx ac g={0.8} wrap>
                  <PhoneOutlined sx={{ fontSize: "12px" }} className="thin" />
                  <Txt secondary>
                    {formatPhone(contact?.phone) || "Unknown"}
                  </Txt>
                </Flx>
              </Box>
            </Tooltip>
            {contact?.company && (
              <Tooltip title={"Contact Company"} arrow placement="right">
                <Box sx={{ width: "max-content" }}>
                  <Flx ac g={0.8} wrap>
                    <StoreOutlined sx={{ fontSize: "12px" }} className="thin" />
                    <Txt secondary>{contact?.company || "Unknown"}</Txt>
                  </Flx>
                </Box>
              </Tooltip>
            )}
            {contact?.appraiserLicenseNumber && (
              <Tooltip
                title={"Appraiser License Number"}
                arrow
                placement="right"
              >
                <Box sx={{ width: "max-content" }}>
                  <Flx ac g={0.8} wrap>
                    <NumbersOutlined
                      sx={{ fontSize: "12px" }}
                      className="thin"
                    />
                    <Txt secondary>
                      {contact?.appraiserLicenseNumber || "Unknown"}
                    </Txt>
                  </Flx>
                </Box>
              </Tooltip>
            )}
          </Flx>
        </Flx>
      ))}
    </Flx>
  );
};

export default LoanRelatedContactCardsRenderer;
